import { useRef, useState } from "react";
import { useMountEffect } from "@react-hookz/web";

/**
 *
 * Returns true when a window is being actively resized
 * Good for shutting off animations while resizing to avoid jank
 */
export default function useWindowIsBeingResized() {
  const [isResizing, setIsResizing] = useState(false);
  const resizeTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useMountEffect(() => {
    const onResize = () => {
      if (isResizing !== true) {
        setIsResizing(true);
      }

      if (resizeTimer.current !== null) {
        clearTimeout(resizeTimer.current);
      }

      resizeTimer.current = setTimeout(() => {
        setIsResizing(false);
        resizeTimer.current = null;
      }, 400);
    };

    const onResizeEnd = () => {
      if (isResizing === false) {
        return;
      }

      setIsResizing(false);
    };

    window.addEventListener("resize", onResize);
    window.addEventListener("resizeend", onResizeEnd);

    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("resizeend", onResizeEnd);
    };
  });

  return isResizing;
}
